import { Injectable } from '@angular/core';
import { DbService } from '../db/db.service';
import { Project } from 'src/app/models/firebase/project';
import { AboutUs } from 'src/app/models/firebase/about-us';
import { ILandingPageAboutUs } from 'src/app/interfaces/landing-page-about-us.interface';

@Injectable({
    providedIn: 'root',
})
export class AboutUsService {
    constructor(private db: DbService) {}

    async getAboutUs(projectId: string): Promise<AboutUs> {
        const data = await this.db.firestore.collection(Project.PATH).doc(projectId).collection(AboutUs.PATH).get();
        if (data.docs.length === 0) {
            return null;
        }
        return data.docs.map((data) => new AboutUs(data.data())).pop();
    }
}
